import {Component} from '@angular/core';
import {CovIconComponent, IconName} from '@cov/ui-angular';
import {TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'cov-floating-inquiry-button',
  imports: [CovIconComponent, TranslocoPipe],
  templateUrl: './floating-inquiry-button.component.html',
  styleUrl: './floating-inquiry-button.component.scss',
})
export class FloatingInquiryButtonComponent {
  protected readonly IconName = IconName;
}
